module.exports = __webpack_public_path__ + "static/media/19ESCAP29.59ebf909.jpg";